import { useGetAccountQuery, useGetMeQuery } from '@/api'
import { DEFAULT_CURRENCY } from '@/types'
import type { CurrencyCode } from '@/types'

/**
 * The currency new records should be created in.
 *
 * Chosen once in the profile instead of being asked in every form that touches
 * money — there were eight such pickers, and nothing kept their answers
 * consistent with each other.
 *
 * This is a default for *new* records only. Anything already saved carries its
 * own currency and must be read from the record, never from here: a signed
 * contract is denominated in what was agreed, and re-reading it through the
 * current setting would restate the obligation.
 *
 * Both queries are cached by RTK Query and already fetched by the app shell, so
 * calling this in a dialog costs nothing.
 */
export function useAccountCurrency(): CurrencyCode {
	const { data: me } = useGetMeQuery()
	const { data: account } = useGetAccountQuery(me?.id ?? '', { skip: !me?.id })

	return account?.currency ?? DEFAULT_CURRENCY
}
